import { useOutletContext } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import type { PortalOutletContext } from "@/pages/artist-portal/ArtistPortalDetailPage";

export function EmergencyContactsTab() {
  const { overview } = useOutletContext<PortalOutletContext>();
  const contacts = overview.emergency_contacts;

  if (contacts.length === 0) {
    return (
      <div className="card p-8 text-center text-sm text-ink-3">
        No emergency contacts yet. The festival will add production staff here
        before the event.
      </div>
    );
  }

  return (
    <ul className="space-y-2">
      {contacts.map((c) => (
        <li
          key={c.id}
          className="card p-3"
        >
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="font-semibold text-ink">{c.name}</div>
              <div className="text-xs text-ink-3">{c.role}</div>
            </div>
            <div className="flex flex-wrap items-center gap-4">
              {c.phone && (
                <a
                  href={`tel:${c.phone}`}
                  className="inline-flex items-center gap-1 text-sm text-accent hover:underline"
                >
                  <Phone className="h-4 w-4" /> {c.phone}
                </a>
              )}
              {c.email && (
                <a
                  href={`mailto:${c.email}`}
                  className="inline-flex items-center gap-1 text-sm text-accent hover:underline"
                >
                  <Mail className="h-4 w-4" /> {c.email}
                </a>
              )}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
